module.exports = __webpack_public_path__ + "img/Cuban Bowl-Chicken.e9dda4b8.jpg";